// extracted by mini-css-extract-plugin
export default {"lanageSelect":"lanageSelect-fXvK5j"};